import $ from 'jquery'

function tabsSwitch() {
  var tabs = $("ul.tabs");
  var tab_content = $(".tabs-content");
  var currentTab = tabs.find(".is-active");
  var currentPanel = tab_content.find(".is-active");

  currentTab.removeClass('is-active').find("[aria-selected]").attr('aria-selected', false);

  if (currentTab.next('li').length !== 0) {
    currentTab.next("li").addClass('is-active').find("[aria-selected]").attr('aria-selected', true);
  } else {
    tabs.find("li:first").addClass('is-active').find("[aria-selected]").attr('aria-selected', true);
  }

  if (currentPanel.next('.tabs-panel').length !== 0) {
    currentPanel.removeClass("is-active").next(".tabs-panel").addClass("is-active");
  } else {
    currentPanel.removeClass("is-active");
    tab_content.find(".tabs-panel:first").addClass("is-active");
  }
}

$("ul.tabs a").on("click", function () {
  if($(this).parent().hasClass('is-active')) {
    setTimeout(tabsSwitch, 10);
  }
});


// WEBPACK FOOTER //
// ./resources/assets/js/partials/tabsSwitch.js